// extracted by mini-css-extract-plugin
export default {"logoText":"Footer_logoText__kYxYF","emailInput":"Footer_emailInput__mzgVT","footerLinks":"Footer_footerLinks__3+3cY"};